const queryKeys = {
  adSets: ['api', 'v1', 'facebook_manager', 'get_adsets'],
  domains: ['api', 'v1', 'facebook_manager', 'get_domains'],
  campaigns: ['api', 'v1', 'facebook_manager', 'get_campaigns'],
  callToActions: ['api', 'v1', 'facebook_manager', 'get_call_to_actions'],
  adTypes: ['api', 'v1', 'facebook_manager', 'get_ad_types'],
  adSettings: ['api', 'v1', 'facebook_manager', 'get_ad_settings'],
  adAccounts: ['api', 'v1', 'facebook_manager', 'get_ad_accounts'],
};
export default queryKeys;